const t = "Зверніть увагу!", e = "Будь ласка, перевірте введені дані", a = { attentionTitle: t, attentionMessage: e };
export {
  e as attentionMessage,
  t as attentionTitle,
  a as default
};
//# sourceMappingURL=notifications.json.js.map
